@let formGroupStammdaten = userService.formGroupStammdaten;
<form [formGroup]="formGroupStammdaten">
  @let newUserValue = newUser();

  <div class="double-card-row-grid">
    @let contingentsValue = contingents();
    @if (formGroupStammdaten | isNil: false) {
      <mat-card appearance="outlined" class="user-edit-main-card">
        <!-- Linker Bereich: Großes Adress-Icon (Gedimmt im Darkmode) -->
        <div class="user-edit-icon-column">
          <div class="icon-avatar-badge">
            <fa-icon
              [icon]="['far', 'address-card']"
              size="3x"
              class="address-avatar-icon"></fa-icon>
          </div>
        </div>

        <!-- Rechter Bereich: Die Formular-Eingabemaske -->
        <div class="user-edit-form-column">
          <!-- Feld: Name -->
          <mat-form-field appearance="fill" class="user-edit-fullwidth-field">
            <mat-label>{{
              'PRODUCT.USERADMIN.STAMMDATEN.NAME' | translate
            }}</mat-label>
            <input
              matInput
              placeholder="Vorname Nachname"
              formControlName="name"
              required />
            <mat-error wmMatErrorMessages></mat-error>
          </mat-form-field>

          <!-- Feld: E-Mail -->
          <mat-form-field appearance="fill" class="user-edit-fullwidth-field">
            <mat-label>{{
              'PRODUCT.USERADMIN.STAMMDATEN.EMAIL' | translate
            }}</mat-label>
            <input
              matInput
              placeholder="E-Mail-Adresse"
              formControlName="email"
              required
              [readonly]="!newUserValue"
              (change)="onCheckEmailToAddToDeliveryTargets()"
              (focus)="isEditingUserName.set(true)"
              (blur)="isEditingUserName.set(false)" />
            <mat-error wmMatErrorMessages></mat-error>
          </mat-form-field>

          <!-- Reihe: Status Checkboxen (Admin & Aktiv-Schalter) -->
          <div class="user-status-checkbox-row">
            <mat-checkbox formControlName="admin" class="custom-color-checkbox">
              {{ 'PRODUCT.USERADMIN.STAMMDATEN.ADMIN' | translate }}
            </mat-checkbox>

            <div class="active-toggle-with-help">
              <mat-checkbox
                #userIsActive
                formControlName="active"
                class="custom-color-checkbox">
                {{ 'PRODUCT.USERADMIN.STAMMDATEN.ACTIVE' | translate }}
              </mat-checkbox>

              <button
                mat-icon-button
                class="help-button inline-help"
                type="button"
                matTooltip="{{
                  'PRODUCT.USERADMIN.STAMMDATEN.INFOACTIVE' | translate
                }}">
                <fa-icon [icon]="['far', 'question-circle']"></fa-icon>
              </button>
            </div>
          </div>

          <!-- Warnungs-Kasten bei blockiertem / inaktivem Benutzer -->
          @if (!userIsActive.checked) {
            <div class="user-blocked-warning-box">
              <fa-icon
                [icon]="['far', 'exclamation-triangle']"
                class="blocked-warning-icon"></fa-icon>
              <div class="blocked-warning-text-content">
                <span class="main-alert-text">
                  {{
                    'PRODUCT.USERADMIN.STAMMDATEN.user_blocked_message'
                      | translate
                  }}
                </span>
                <span class="sub-alert-text">
                  {{
                    'PRODUCT.USERADMIN.STAMMDATEN.activate_checkbox' | translate
                  }}
                  <strong>{{
                    'PRODUCT.USERADMIN.STAMMDATEN.active' | translate
                  }}</strong>
                  {{
                    'PRODUCT.USERADMIN.STAMMDATEN.lift_restriction' | translate
                  }}
                </span>
              </div>
            </div>
          }

          <!-- Sektion: Vertragslaufzeit (Von / Bis Kalender-Reihe) -->
          <div class="contract-dates-layout-row">
            <!-- Kalender: Startdatum -->
            <mat-form-field
              appearance="fill"
              class="contract-date-picker-field">
              <mat-label>
                {{ 'PRODUCT.USERADMIN.CONTRACTTIMERANGE' | translate }}
                {{ 'PRODUCT.USERADMIN.FROM' | translate }}
              </mat-label>
              <input
                matInput
                [matDatepicker]="picker2"
                formControlName="dateFrom" />
              <mat-datepicker-toggle matSuffix [for]="picker2">
                <fa-icon
                  matDatepickerToggleIcon
                  [icon]="['far', 'calendar-alt']"
                  transform="shrink-2"></fa-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
              <mat-error wmMatErrorMessages></mat-error>
            </mat-form-field>

            <!-- Checkbox: Unbefristet -->
            <mat-checkbox
              #userEndless
              formControlName="endless"
              class="custom-color-checkbox endless-time-checkbox">
              {{ 'PRODUCT.USERADMIN.ENDLESSTIME' | translate }}
            </mat-checkbox>

            <!-- Kalender: Enddatum (Bedingt eingeblendet) -->
            @if (!userEndless.checked) {
              <mat-form-field
                appearance="fill"
                class="contract-date-picker-field slide-in-date-field">
                <mat-label>
                  {{ 'PRODUCT.USERADMIN.CONTRACTTIMERANGE' | translate }}
                  {{ 'PRODUCT.USERADMIN.TO' | translate }}
                </mat-label>
                <input
                  matInput
                  [matDatepicker]="picker3"
                  formControlName="dateTo" />
                <mat-datepicker-toggle matSuffix [for]="picker3">
                  <fa-icon
                    matDatepickerToggleIcon
                    [icon]="['far', 'calendar-alt']"
                    transform="shrink-2"></fa-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #picker3></mat-datepicker>
                <mat-error wmMatErrorMessages></mat-error>
              </mat-form-field>
            }
          </div>

          <!-- Fußnote für Pflichtfelder -->
          @if (newUserValue) {
            <p class="form-mandatory-footnote-text">
              * {{ 'PRODUCT.USERADMIN.MANDATORYFIELDS' | translate }}
            </p>
          }
        </div>
      </mat-card>
    }

    @if (
      (formGroupStammdaten | isNil: false) &&
      formGroupStammdaten.controls['name']?.valid &&
      formGroupStammdaten.controls['email']?.valid
    ) {
      @let usedContingentsValue = userService.usedContingents();

      <mat-card
        appearance="outlined"
        class="user-edit-main-card user-delivery-targets-card">
        <!-- 1. HEADLINE & INTRO ZONE -->
        <div class="delivery-targets-intro">
          <h3 class="delivery-main-title">
            {{ 'PRODUCT.USERADMIN.DELIVERY.TARGETSFOR' | translate }}
            <span class="target-user-name">{{
              formGroupStammdaten.controls['name'].value
            }}</span>
          </h3>
          <p class="text-description-muted">
            {{ 'PRODUCT.USERADMIN.DELIVERY.INPUTTARGETS' | translate }}
          </p>
        </div>

        <!-- 2. DAS SEITEN-RASTER FÜR DIE VERSANDWEGE -->
        <div class="delivery-channels-list">
          @for (targetType of ['email', 'sms', 'fax']; track $index) {
            <div
              class="delivery-channel-row"
              [class.channel-disabled]="
                targetType !== 'email' &&
                usedContingentsValue[targetType] >= contingentsValue[targetType]
              ">
              <!-- Spalte 1: Icon & Typ-Label -->

              <fa-icon
                [icon]="deliveryTargetIcons()[targetType]"
                size="lg"
                class="channel-type-icon"></fa-icon>
              <span class="channel-type-label">
                {{ 'SETTINGS.SENDMAN.TYPE.' + targetType | translate }}
              </span>
            </div>

            <!-- Spalte 2: Kontingent-Statusanzeiger (Asterisk) -->
            <div class="channel-status-indicator-zone">
              @if (targetType !== 'email') {
                <span
                  class="contingent-asterisk-tooltip-wrapper"
                  matTooltip="{{
                    'PRODUCT.USERADMIN.CONTINGENT.TEXT1' | translate
                  }} {{
                    'PRODUCT.USERADMIN.CONTINGENT.' + targetType + '_SHORT'
                      | translate
                  }}: {{ contingentsValue[targetType] }}. {{
                    'PRODUCT.USERADMIN.CONTINGENT.TEXT2' | translate
                  }}: {{ usedContingentsValue[targetType] }}">
                  <fa-icon
                    [icon]="['far', 'asterisk']"
                    class="contingent-status-star"
                    [ngClass]="
                      usedContingentsValue[targetType] <
                      contingentsValue[targetType]
                        ? 'star-positive'
                        : 'star-negative'
                    ">
                  </fa-icon>
                </span>
              }
            </div>

            <!-- Spalte 3: Chip-Grid & Eingabefeld (Adressverwaltung) -->
            <div class="channel-addresses-input-zone">
              <mat-chip-grid
                #chipList
                aria-label="Adressen"
                class="custom-delivery-chip-grid">
                @for (address of deliveryTargets()[targetType]; track $index) {
                  <mat-chip-row
                    [removable]="
                      address !== formGroupStammdaten.controls['email'].value
                    "
                    class="custom-theme-chip"
                    (removed)="onRemove(targetType, address)">
                    <span class="chip-address-text">
                      @if (targetType === 'email') {
                        {{ address }}
                      } @else {
                        {{ address | phonenumber }}
                      }
                    </span>

                    @if (
                      address !== formGroupStammdaten.controls['email'].value
                    ) {
                      <mat-icon matChipRemove class="chip-remove-cross-icon"
                        >cancel</mat-icon
                      >
                    }
                  </mat-chip-row>
                }

                <!-- Inline Eingabefeld für neue Adressen -->
                @let deliveryTargetControl = userService.deliveryTargetControl;
                <mat-form-field
                  appearance="fill"
                  class="chip-inline-form-field"
                  subscriptSizing="dynamic">
                  <input
                    matInput
                    placeholder="{{
                      ((deliveryTargetControl[targetType].errors | isNil)
                        ? 'PRODUCT.USERADMIN.DELIVERY.NEWTARGET'
                        : 'PRODUCT.USERADMIN.DELIVERY.WRONGTARGETFORMAT'
                      ) | translate
                    }}"
                    [disabled]="
                      targetType !== 'email' &&
                      usedContingentsValue[targetType] >=
                        contingentsValue[targetType]
                    "
                    [formControl]="deliveryTargetControl[targetType]"
                    [matChipInputFor]="chipList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes()"
                    [matChipInputAddOnBlur]="true"
                    (matChipInputTokenEnd)="onAdd(targetType, $event)" />
                  <mat-error wmMatErrorMessages></mat-error>
                </mat-form-field>
              </mat-chip-grid>

              <!-- Kontingent Metadaten-Zähler unterhalb der Chips -->
              <div class="channel-footnote-meta">
                @if (
                  targetType !== 'email' &&
                  usedContingentsValue[targetType] >=
                    contingentsValue[targetType]
                ) {
                  <span class="contingent-full-badge">
                    ({{ 'PRODUCT.USERADMIN.CONTINGENT.FULL' | translate }})
                  </span>
                }
                @if (targetType !== 'email') {
                  <span class="contingent-counter-string">
                    {{ 'PRODUCT.USERADMIN.CONTINGENT.USED' | translate }}:
                    <strong>{{ usedContingentsValue[targetType] }}</strong> /
                    {{ contingentsValue[targetType] }}
                  </span>
                }
              </div>
            </div>
          }
        </div>

        <!-- 3. FOOTER BEREICH: AUTOMATISCHER VERSAND (Nur bei Neuanlage) -->
        @if (newUserValue) {
          <div class="delivery-auto-dispatch-zone">
            <mat-divider class="delivery-footer-divider"></mat-divider>

            <mat-checkbox
              formControlName="autoDelivery"
              (change)="onAutoDelivery($event)"
              class="custom-color-checkbox auto-delivery-checkbox">
              <span class="auto-delivery-checkbox-label">
                {{ 'PRODUCT.USERADMIN.DELIVERY.AUTO' | translate }}
              </span>
            </mat-checkbox>

            <div class="explanation-box-fallback auto-dispatch-explanation">
              {{ 'PRODUCT.USERADMIN.DELIVERY.AUTOINFO1' | translate }}
              <strong>{{
                'PRODUCT.USERADMIN.DELIVERY.AUTOINFO2' | translate
              }}</strong
              >,
              {{ 'PRODUCT.USERADMIN.DELIVERY.AUTOINFO3' | translate }}
              <strong>{{
                'PRODUCT.USERADMIN.DELIVERY.AUTOINFO4' | translate
              }}</strong>
              {{ 'PRODUCT.USERADMIN.DELIVERY.AUTOINFO5' | translate }}
            </div>
          </div>
        }
      </mat-card>
    }
  </div>

  <div class="button-row">
    <!--cancel button-->
    <button
      mat-raised-button
      class="btn-app-cancel"
      type="button"
      (click)="onCancel()">
      {{ 'PRODUCT.USERADMIN.CANCEL' | translate }}
    </button>
    &nbsp;
    @let isEditingUserNameValue = isEditingUserName();

    <button
      type="button"
      mat-raised-button
      class="btn-app-next"
      matStepperNext
      (click)="onLog()"
      [disabled]="isEditingUserNameValue">
      {{ 'PRODUCT.USERADMIN.NEXT' | translate }}
    </button>
    &nbsp;&nbsp;
    <!--submit button-->
    @let isSavingValue = isSaving();
    @let loadingUserListValue = userService.loadingUserList();
    @if (newUserValue) {
      <button
        type="button"
        [disabled]="
          isSavingValue ||
          formGroupStammdaten.invalid ||
          loadingUserListValue ||
          isEditingUserNameValue ||
          !userService.formGroupWebsite.controls['active'].value
        "
        mat-raised-button
        class="btn-app-save"
        (click)="onSubmit()"
        [disabled]="!formGroupStammdaten.valid">
        {{ 'PRODUCT.USERADMIN.EXPRESSSAVE' | translate }}
      </button>
    } @else {
      <!--express save button-->
      <button
        [disabled]="isSavingValue || loadingUserListValue"
        mat-raised-button
        class="btn-app-save"
        (click)="onSummarizeUser()">
        {{ 'PRODUCT.USERADMIN.SAVE' | translate }}
      </button>
    }
  </div>
</form>
